<template>
  <div >
    <v-layout 
      style="position:absolute;right:0rem;top:0;z-index:1">
        <v-btn 
          fab small color="white" 
          v-on:click="fitContent()"
        >
          <v-icon dark>zoom_out_map</v-icon>
        </v-btn>
        <v-btn 
          fab small color="white" 
          v-on:click="updateShowLabels()"
        >
          <v-icon dark v-if="showLabels">label</v-icon>
          <v-icon dark v-else>label_off</v-icon>
        </v-btn>
    </v-layout>
    <div v-if="height" id="mapid" :style="'height: '+((height)?height:'700px')+';width: 100%;z-index:0;'"></div>
    <div v-else 
      id="mapid" 
      style="
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;;width: 100%;z-index:0;
      ">
    </div>
  </div>
</template>

<script>
import L from "leaflet/dist/leaflet"
import 'leaflet/dist/leaflet.css'
import "leaflet-draw/dist/leaflet.draw.css"
import "leaflet-draw"
import "leaflet.polyline.snakeanim/L.Polyline.SnakeAnim"
import { OverlayImage } from "./models/Map"

export default {
  components: { },
  name: 'MapView',
  props: {
    perimeters: Array,
    markers: Array,
    labels: Array,
    // [{
    //    id
    //    coordinates: { latitude,longitude }
    //    htmlContentTooltip,
    //    fitZoom
    // }],
    paths: Array,
    // [{
    //    id
    //    markers:[{
    //      id
    //      coordinates: { latitude,longitude }
    //      info: { title, content }
    //    }]
    // }]
    height: String,
    image: OverlayImage

  },
  data(){
    return{
      showedLabels: [],
      showLabels: false,
      map: null,
      mapMarkers: [],
      layer: null,
      markerLayer: null,
      // [{
      //    id,
      //    leafletMarker,
      //    leafletPanel,
      //    fitZoom
      // }],
      mapPaths:[],
      // [{
      //    id,
      //    leafletPath
      // }],
      colors: [
        '#f53794',
        '#f67019',
        '#537bc4',
        '#acc236',
        '#166a8f',
        '#00a950',
        '#58595b',
        '#8549ba',
        '#4dc9f6'
      ],
      areas: [],
    }
  },

  mounted(){
    this.map = L.map("mapid", {
        center: [0, 0],
        zoom: 1,
    });
    var mapBounds = L.latLngBounds([
        [61.002838, 8.467039],
        [2.192217, 87.030720]
    ]);
    this.map.fitBounds(mapBounds);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {maxNativeZoom: 20, maxZoom: 20}).addTo(this.map);
    this.map.on('click', (e) => {
      this.$emit("clickMap",{latitude:e.latlng.lat, longitude:e.latlng.lng});
    });

    // FeatureGroup is to store editable layers
    this.markerLayer = new L.FeatureGroup()
    this.map.addLayer(this.markerLayer)
    this.drawnItems = new L.FeatureGroup()
    this.map.addLayer(this.drawnItems)
    var drawControl = new L.Control.Draw({
      draw: {
        toolbar: {
          buttons: {
            polygon: 'Draw a polygon'
          }
        },
        polyline: false,
        polygon: true,
        circle: false,
        rectangle: false,
        circlemarker: false,
        marker: false
      }/*,
      edit: {
          featureGroup: this.drawnItems,
          remove: false
      }*/
    });
    this.map.addControl(drawControl);
    this.map.on(L.Draw.Event.CREATED, (e) => {
      var type = e.layerType;
      var layer = e.layer;
      layer.options.color = "green"
      this.map.removeLayer(this.drawnItems)
      this.drawnItems = new L.FeatureGroup()
      this.drawnItems.addTo(this.map)
      this.drawnItems.addLayer(layer);
      // console.log("Polygon drawed", e);
      if (type === 'polygon') {
        // console.log(JSON.stringify(layer._latlngs[0]));
        this.$emit("created", layer._latlngs[0]);
      }
    });
    this.drawLabels(this.labels)
  },

  watch: {

    paths: {
      deep: true,
      handler: function (newPaths){
        // ** Remove all paths from map **
        this.mapPaths.forEach( 
          mapPath => {
            if(mapPath.animationIntervalId)
              clearInterval(mapPath.animationIntervalId);
            if(mapPath.leafletPath)
                mapPath.leafletPath.remove();
            if(mapPath.leafletPathBackground)
                mapPath.leafletPathBackground.remove();
            if(mapPath.leafletMarkers)
              mapPath.leafletMarkers.forEach( m => m.removeFrom(this.map));
          }
        );
        this.mapPaths.splice(0);
        newPaths.forEach(
          (newPath) => {
            
            let path;
            let pathBackground;
            let animationIntervalId;
            if(newPath.markers.length>1){
              pathBackground = L.polyline(
                newPath.markers.map(marker => [marker.coordinates.latitude, marker.coordinates.longitude]), 
                {
                  opacity: 0.5,
                  "weight": 5,
                  "color": this.colors[(this.mapPaths.length % this.colors.length + this.colors.length) % this.colors.length ] ,
                }
              );
              pathBackground.addTo(this.map)
              path = L.polyline(
              newPath.markers.map(marker => new L.LatLng(marker.coordinates.latitude, marker.coordinates.longitude)), 
                {
                  snakingSpeed: 500, 
                  "weight": 5,
                  "color": this.colors[(this.mapPaths.length % this.colors.length + this.colors.length) % this.colors.length ] ,
                }
              );
              const pathToSnalke = path.addTo(this.map)
              animationIntervalId = setInterval(function(){pathToSnalke.snakeIn()}, 500)
              
              // path = antPath(newPath.markers.map(marker => [marker.coordinates.latitude, marker.coordinates.longitude]), {
              //   "delay": 166,
              //   "dashArray": [
              //     10,
              //     20
              //   ],
              //   "weight": 5,
              //   "color": this.colors[(this.mapPaths.length % this.colors.length + this.colors.length) % this.colors.length ] ,
              //   "pulseColor": "#FFFFFF",
              //   "paused": false,
              //   "reverse": false,
              //   "hardwareAccelerated": true
              // });
              // path.addTo(this.map);
            }

            let i = 0;
            let markers = newPath.markers.map( 
              m => {
                let leafletMarker = createMarker(m,this.colors[(this.mapPaths.length % this.colors.length + this.colors.length) % this.colors.length], i == 0, (i == newPath.markers.length-1));
                leafletMarker.addTo(this.map);
                leafletMarker.on('click', ()=> this.$emit('clickMarker',m))
                i++;
                return leafletMarker;
              });
            this.mapPaths.push({
              id: newPath.id,
              leafletPath: path,
              leafletPathBackground: pathBackground,
              leafletMarkers: markers,
              animationIntervalId: animationIntervalId
            });
          }
        );
        if(this.mapPaths.length>=1){
          let group = new L.featureGroup(
            this.mapPaths.reduce(
              (allMarkers,path) => 
                allMarkers.concat(path.leafletMarkers)
            ,[])
          )
          this.map.fitBounds(group.getBounds());
        }
      }
    },

    markers:{
      deep: true,
      handler(newMarkers){
        let newMapMarkers = [];
        // ** Remove old unexisting marker **
        this.mapMarkers.forEach( 
          mapMarker => {
            let foundMarker = newMarkers.find(newMarker => newMarker.id == mapMarker.id);
            if(!foundMarker)
            {
              mapMarker.leafletMarker.removeFrom(this.map);
            }else{
              newMapMarkers.push(mapMarker);
            }
          }
        );
        this.mapMarkers.splice(0);
        this.mapMarkers = newMapMarkers;

        newMarkers.map(
          (newMarker) => {
            let foundMarker = this.mapMarkers.find(mapMarker => mapMarker.id == newMarker.id);
            if(foundMarker){
              // ** Set new position with animation **
              let deltaLat = newMarker.coordinates.latitude - foundMarker.leafletMarker.getLatLng().lat;
              let deltaLng = newMarker.coordinates.longitude - foundMarker.leafletMarker.getLatLng().lng;
              if(deltaLat!=0 || deltaLng!=0)
              {
                let stepLat = deltaLat/100;
                let stepLng = deltaLng/100;
                moving(
                  foundMarker.leafletMarker, 
                  { 
                    latitude: foundMarker.leafletMarker.getLatLng().lat, 
                    longitude: foundMarker.leafletMarker.getLatLng().lng
                  },
                  newMarker.coordinates, 
                  {
                    latitude: stepLat,
                    longitude:stepLng
                  }, 
                  0,
                  newMarker.htmlContentTooltip
                );
              }
            }else{
              let leafletMarker = createMarker(newMarker,this.colors[(this.mapMarkers.length % this.colors.length + this.colors.length) % this.colors.length]);
              leafletMarker.addTo(this.map);
              leafletMarker.on('click', ()=> this.$emit('clickMarker',newMarker))
              this.mapMarkers.push({
                id: newMarker.id,
                leafletMarker:leafletMarker,
                fitZoom: newMarker.fitZoom
              })

            }
          }
        );
        if(this.mapMarkers.filter(mm => mm.fitZoom!=false).length>=1){
          let group = new L.featureGroup(this.mapMarkers.map(mm => mm.leafletMarker));
          this.map.fitBounds(group.getBounds().pad(0.5));
        }
      }
    },

    perimeters: {
      handler: function(poligons) {
        this.drawPolygon(poligons)
      }
    },

    labels: {
      handler() {
        this.drawLabels(this.labels);
      },
      deep: true
    },

    image(){
      if (this.layer) {
        this.map.removeLayer(this.layer);
      }
      if(this.image){
        this.buildImageLayer(this.image);
      }
    }
  },

  methods:{

    updateShowLabels(){
      this.showLabels = !this.showLabels;
      this.drawLabels(this.labels);
    },

    fitContent(){
      if(this.mapMarkers.length>=1){
        let group = new L.featureGroup(this.mapMarkers.map(mm => mm.leafletMarker));
        this.map.fitBounds(group.getBounds().pad(0.5));
      }
      if(this.mapPaths.length>=1){
        let group = new L.featureGroup(
          this.mapPaths.reduce(
            (allMarkers,path) => 
              allMarkers.concat(path.leafletMarkers)
          ,[])
        )
        this.map.fitBounds(group.getBounds().pad(0.5));
      }
    },

    drawPolygon(poligons){
      this.map.removeLayer(this.drawnItems);
      this.drawnItems = new L.FeatureGroup();
      this.drawnItems.addTo(this.map)
      if (poligons.length !== 0) {
        poligons.forEach(poligon => {
            L.polygon(poligon).addTo(this.drawnItems)
        });
      }
    },

    drawLabels(labels){
      if(this.showLabels){
        for(const sl of this.showedLabels){
          sl.removeFrom(this.map);
        }
        this.showedLabels.slice(0);
        for(const l of labels){
          // L.popup()
          // .setLatLng(new L.LatLng(l.coordinates.latitude, l.coordinates.longitude))
          // .setContent(l.html)
          // .openOn(this.map);
          const marker = new L.marker([l.coordinates.latitude, l.coordinates.longitude], { opacity: 0.01 }); //opacity may be set to zero
          marker.bindTooltip(l.html, {permanent: true, className: "map-label", offset: [0, 0], opacity: 0.9, direction:"left"});
          marker.addTo(this.map);
          this.showedLabels.push(marker);
        }
      } else {
        for(const sl of this.showedLabels){
          sl.removeFrom(this.map);
        }
        this.showedLabels.slice(0);
      }
    },

    buildImageLayer(overlayImage){
      //var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
      const imageBounds = [overlayImage.topLeftCoord, overlayImage.bottomRightCoord];// [[40.712216, -74.22655], [40.773941, -74.12544]];
      this.layer = new L.imageOverlay(overlayImage.url, imageBounds);
      this.layer.addTo(this.map);
      let mapBounds;
      if(overlayImage.boundBottomRightCoord && overlayImage.boundTopLeftCoord){
        const customImageBounds = [overlayImage.boundTopLeftCoord, overlayImage.boundBottomRightCoord];
        mapBounds = L.latLngBounds(customImageBounds);
      } else {
        mapBounds = L.latLngBounds(imageBounds);
      }
      this.map.fitBounds(mapBounds);
      if(overlayImage.zoom){
        this.map.setZoom(overlayImage.zoom);
      }
      
    }

  }
}

function moving(leafletMarker, startCoordinates, stopCoordinates, step, recursiveIndex, htmlContentTooltip){

  if(htmlContentTooltip){
    const isOpenTooltip = leafletMarker.isTooltipOpen();
    const isOpenPopup = leafletMarker.isPopupOpen();

    leafletMarker.closeTooltip();
    leafletMarker.unbindTooltip();
    leafletMarker.closePopup();
    leafletMarker.unbindPopup();
    leafletMarker.bindPopup("<div style='padding:0;margin-top:-13.5px;margin-bottom:-14px;margin-left:-20px;margin-right:-21px'>"+tooltipGenerator(htmlContentTooltip.title,htmlContentTooltip.body)+"</div>", 
      {
          direction: 'right',
          permanent: false,
          sticky: true,
          offset: [20, 100],
          opacity: 0.75,
          backgroundColor: 'black'
      }
    );
    leafletMarker.bindTooltip("<div style='padding:0;margin:-13.5px;align-content: left !important;'>"+tooltipGenerator(htmlContentTooltip.title,htmlContentTooltip.body)+"</div>", 
      {
          direction: 'right',
          permanent: false,
          sticky: true,
          offset: [0, 0],
          opacity: 0.75,
          backgroundColor: 'black'
      }
    );

    if(isOpenTooltip)
      leafletMarker.openTooltip();

    if(isOpenPopup)
      leafletMarker.openPopup();
  }

  if(recursiveIndex==100){
    leafletMarker.setLatLng(L.latLng(
      stopCoordinates.latitude, 
      stopCoordinates.longitude
    ));
    return;
  }
  
  startCoordinates.longitude += step.longitude;
  startCoordinates.latitude += step.latitude;
  leafletMarker.setLatLng(L.latLng(
    startCoordinates.latitude, 
    startCoordinates.longitude
  ));
  recursiveIndex+=1;
  setTimeout(()=>moving(leafletMarker, startCoordinates, stopCoordinates, step, recursiveIndex),20);

}

function tooltipGenerator(htmlTitle,htmlBody){
  return `
    <style>
    .card {
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      transition: 0.3s;background-color:white;
      width: 100%;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .card:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    .container {
    }
    </style>
    </head>
    <div class="card" style="width:300px;">
      <div class="container" style="height:30%:width:100%;padding:0rem">
        <div style="background-color:#29B6F6;padding:5px;color:#FAFAFA">
        ${htmlTitle}
        </div>
        <div style="height:70%:width:100%;padding:5px;background-color:white">
        ${htmlBody}
        </div>
      </div>
    </div>
    `
}


function createMarker(newMarker, color, start, end){
  let delta = 0
  let dur = "1.5s"

  let svg = `
    <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" >
      ${newMarker.evt?'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="38px" height="48px"><path d="M0 0h24v24H0z" fill="red"/><path d="M7 2v11h3v9l7-12h-4l4-8z"/></svg>':''}
      ${newMarker.tel?'<svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 2 24 60" fill="white" width="98px" height="98px"><path d="M0 0h24v24H0z" fill="green"/><path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"/></svg>':''}
      <circle cx="50" cy="50" r="35" stroke="${color}" stroke-width="3" fill="${color}" class="blob" >
        <animate attributeType="SVG" attributeName="r" begin="0s" dur="${dur}" repeatCount="indefinite" from="5%" to="45%"/>
        <animate attributeType="CSS" attributeName="stroke-width" begin="0s"  dur="1.5s" repeatCount="indefinite" from="10%" to="0%" />
        <animate attributeType="CSS" attributeName="opacity" begin="0s"  dur="1.5s" repeatCount="indefinite" from="1" to="0"/>
      </circle>
    </svg>`;

  if(start && !(start && end)){
    //svg = '<svg height="256" viewBox="0 0 58 58" width="256" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="037---Waypoint-Flag" fill-rule="nonzero" transform="translate(-1 -1)"><path id="Shape" d="m58.44 30.6c-11.88 14.2-32.78-3.93-44.27 11.64l-.66-2.34v-.01c-2.29-8.19-4.58-16.3833333-6.87-24.58-.22-.78-.43-1.56-.65-2.34 11.49-15.57 32.4 2.56 44.27-11.64.58-.7 1.13-.4 1.01.62-.06.48-.13.96-.19 1.43-.69 5-1.53 9.44-2.49 13.46-.27 1.13-.54 2.22-.83 3.29-.0181734.0757458-.0315335.1525661-.04.23-.0106736.2802805.1027422.5510151.31.74 2.9783401 2.7019905 6.2761919 5.0292932 9.82 6.93.28.14.55.27.82.39.46.2.35 1.48-.23 2.18z" fill="'+color+'"/><path id="Shape" d="m58.44 30.6c-11.88 14.2-32.78-3.93-44.27 11.64-.22-.78-1.95-.87-2.17-1.65v-.01c-2.29-8.19-4.58-16.3833333-6.87-24.58-.22-.78 1.08-2.25.86-3.03 11.49-15.57 32.4 2.56 44.27-11.64.58-.7 1.13-.4 1.01.62-.06.48-.13.96-.19 1.43-.69 5-1.53 9.44-2.49 13.46-.27 1.13-.54 2.22-.83 3.29-.0181734.0757458-.0315335.1525661-.04.23-.0106736.2802805.1027422.5510151.31.74 2.9783401 2.7019905 6.2761919 5.0292932 9.82 6.93.28.14.55.27.82.39.46.2.35 1.48-.23 2.18z" fill="'+color+'"/><path id="Shape" d="m9.45150963 10.0111708h.1433c.64015307 0 1.25408707.2542998 1.70674367.7069563.4526565.4526566.7069563 1.0665906.7069563 1.7067437v45.3626c0 1.0664618-.8645381 1.931-1.931 1.931h-1.10879997c-1.06646186 0-1.931-.8645382-1.931-1.931v-45.3626c0-1.3330497 1.0806503-2.4137 2.4137-2.4137z" fill="orange" transform="matrix(.963 -.269 .269 .963 -9.032 3.849)"/></g></g></svg>'
    svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.4,6L14,4H5V21H7V14H12.6L13,16H20V6H14.4Z" /></svg>'
    delta = 0
  }
  if(end && !(start && end)){
    // svg = '<svg height="256" viewBox="0 0 58 58" width="256" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="036---Final-Destination" fill-rule="nonzero"  transform="translate(-1)"><path id="Shape" d="m58.63 26.65c-2.3921107 1.7703901-5.0299443 3.181951-7.83 4.19-.0784363.0311466-.158563.0578555-.24.08-.36.14-.72.26-1.09.38-.92.31-1.86.58-2.81.83-.32.09-.64.17-.97.25-.15.04-.3.08-.45.11-.4.1-.8.19-1.21.28-.0721757.0214037-.1456631.0381054-.22.05-.4.09-.8.17-1.2.25-.34.07-.67.14-1 .2-.47.09-.95.18-1.42.27-.31.06-.63.12-.94.17-.09.02-.18.03-.26.05-.09.02-.17.03-.26.05-.02 0-.05.01-.07.01-1.19.21-2.37.41-3.56.62h-.02c-.25.05-.49.09-.73.13-.13.03-.27.05-.4.08l-.33.06c-.49.09-.98.18-1.46.27h-.02c-.19.04-.39.08-.58.12-.0390411.0115077-.079337.0182237-.12.02-.43.09-.85.18-1.27.27-.3.06-.6.13-.89.2-.41.09-.82.19-1.22.29-.0710467.0119156-.1412066.0286204-.21.05-.48.12-.95.24-1.42.37-1.18.33-2.34.7-3.48 1.12-3.0259473 1.0854449-5.8584948 2.6485789-8.39 4.63-1.1-2.96-3.19-5.42-4.29-8.38s-2.19-5.92-3.29-8.88-1.19-6.42-2.29-9.38c2.52943447-1.9820533 5.3626461-3.542177 8.39-4.62.56-.21 1.11-.4 1.68-.58.55-.18 1.1-.34 1.65-.5.0153542-.00808367.0327178-.0115564.05-.01.57-.17 1.15-.32 1.73-.46.1-.03.21-.05.32-.08.47-.11.94-.22 1.42-.33.23-.05.47-.1.71-.15.35-.07.69-.14 1.04-.21.13-.03.26-.06.39-.08.03-.01.07-.01.1-.02.0326539-.00826854.0663553-.01163868.1-.01.13-.03.27-.06.4-.08.0217823-.01122733.0455742-.01802502.07-.02 1.69-.32 3.4-.61 5.1-.91.86-.15 1.73-.31 2.59-.47.43-.07.87-.16 1.3-.24.62-.12 1.24-.24 1.85-.38.52-.11 1.04-.22 1.55-.35.34-.08.67-.16 1-.24.48-.12.95-.25 1.42-.38.55-.15 1.1-.32 1.64-.49.48-.15.96-.32 1.43-.49 2.7320998-.95989247 5.3169932-2.29609385 7.68-3.97.2408387-.17616806.5500121-.23005474.8362489-.14575212s.5168467.29716659.6237511.57575212c.95 2.56 1.9 5.13 2.84 7.69 1.1 2.96 2.1966667 5.9166667 3.29 8.87 1.02 2.74 2.03 5.48 3.05 8.22.1470017.3950605.0216564.8398341-.31 1.1z" fill="#ecf0f1"/><g fill="#393f4a"><path id="Shape" d="m25.56 17.24c-3.1256556.5526777-6.1996782 1.3655041-9.19 2.43-1.1-2.96-2.1966667-5.92-3.29-8.88.56-.21 1.11-.4 1.68-.58.55-.18 1.1-.34 1.65-.5.0153542-.00808367.0327178-.0115564.05-.01.57-.17 1.15-.32 1.73-.46.1-.03.21-.05.32-.08.47-.11.94-.22 1.42-.33.23-.05.47-.1.71-.15.35-.07.69-.14 1.04-.21.13-.03.26-.06.39-.08.03-.01.07-.01.1-.02.0326539-.00826854.0663553-.01163868.1-.01 1.1 2.96 2.1966667 5.92 3.29 8.88z"/><path id="Shape" d="m32.14 34.98c-.19.04-.39.08-.58.12-.0390411.0115077-.079337.0182237-.12.02-.43.09-.85.18-1.27.27-.3.06-.6.13-.89.2-.41.09-.82.19-1.22.29-.0710467.0119156-.1412066.0286204-.21.05-.48.12-.95.24-1.42.37-1.18.33-2.34.7-3.48 1.12-1.1-2.95-2.1966667-5.9066667-3.29-8.87 2.9918713-1.0619302 6.0654019-1.877971 9.19-2.44 1.1 2.96 2.1966667 5.9166667 3.29 8.87z"/><path id="Shape" d="m44.22 13.08c-2.9948988 1.0631727-6.071854 1.8792348-9.2 2.44-1.09-2.96-2.1866667-5.92-3.29-8.88.62-.12 1.24-.24 1.85-.38.52-.11 1.04-.22 1.55-.35.34-.08.67-.16 1-.24.48-.12.95-.25 1.42-.38.55-.15 1.1-.32 1.64-.49.48-.15.96-.32 1.43-.49.1053811-.0306177.2088897-.06734655.31-.11 1.1 2.96 2.1966667 5.92 3.29 8.88z"/><path id="Shape" d="m50.8 30.84c-.0784363.0311466-.158563.0578555-.24.08-.36.14-.72.26-1.09.38-.92.31-1.86.58-2.81.83-.32.09-.64.17-.97.25-.15.04-.3.08-.45.11-.4.1-.8.19-1.21.28-.0721757.0214037-.1456631.0381054-.22.05-.4.09-.8.17-1.2.25-.34.07-.67.14-1 .2-1.1-2.96-2.1966667-5.92-3.29-8.88 3.1245981-.562029 6.1981287-1.3780698 9.19-2.44 1.09 2.96 2.1866667 5.9233333 3.29 8.89z"/><path id="Shape" d="m19.66 28.55c-3.0273539 1.077823-5.8605655 2.6379467-8.39 4.62-1.1-2.96-2.19666667-5.92-3.29-8.88 2.5294345-1.9820533 5.3626461-3.542177 8.39-4.62 1.1 2.96 2.1966667 5.92 3.29 8.88z"/><path id="Shape" d="m38.32 24.39c-3.14.61-6.33 1.1-9.47 1.72-1.1-2.96-2.1966667-5.9166667-3.29-8.87 3.14-.62 6.32-1.11 9.46-1.72 1.1 2.96 2.2 5.9166667 3.3 8.87z"/><path id="Shape" d="m55.89 17.33c-2.5258826 1.9818777-5.3557788 3.5420353-8.38 4.62-1.1-2.96-2.1966667-5.9166667-3.29-8.87 3.0206038-1.0859829 5.8492682-2.6454613 8.38-4.62 1.1 2.96 2.1966667 5.9166667 3.29 8.87z"/></g><path id="Shape" d="m18.065 57.2568-.6887.2552c-1.0355263.3836363-2.1860142-.1446032-2.57-1.18l-13.7731-37.1671c-.14180548-.3829359-.02217752-.813645.2968-1.0686l3.3608-2.6863 14.5546 39.2765c.3837943 1.0357266-.1446837 2.186478-1.1804 2.5703z" fill="#cf976a"/></g></g></svg>'
    svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.4,6H20V16H13L12.6,14H7V21H5V4H14L14.4,6M14,14H16V12H18V10H16V8H14V10L13,8V6H11V8H9V6H7V8H9V10H7V12H9V10H11V12H13V10L14,12V14M11,10V8H13V10H11M14,10H16V12H14V10Z" /></svg>'
  
    delta = 0
  }
  
  let iconUrl = encodeURI("data:image/svg+xml," + svg).replace(/#/g,'%23');
  
  // ** Add new marker to map **
  let icon = L.icon({
    iconUrl: iconUrl,//'./device.png',
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [-20, -86]
  });
  let leafletMarker = L.marker(
    L.latLng(
      newMarker.coordinates.latitude+delta, 
      newMarker.coordinates.longitude+delta
    ),
    { icon: icon }
  );

  if(newMarker.htmlContentTooltip){
    leafletMarker.bindPopup("<div style='padding:0;margin-top:-13.5px;margin-bottom:-14px;margin-left:-20px;margin-right:-21px'>"+tooltipGenerator(newMarker.htmlContentTooltip.title,newMarker.htmlContentTooltip.body)+"</div>", 
      {
          direction: 'right',
          permanent: false,
          sticky: true,
          offset: [20, 100],
          opacity: 0.75,
          backgroundColor: 'black'
      }
    );
    leafletMarker.bindTooltip("<div style='padding:0;margin:-13.5px;align-content: left !important;'>"+tooltipGenerator(newMarker.htmlContentTooltip.title,newMarker.htmlContentTooltip.body)+"</div>", 
      {
          direction: 'right',
          permanent: false,
          sticky: true,
          offset: [0, 0],
          opacity: 0.75,
          backgroundColor: 'black'
      }
    );
  }

  return leafletMarker
}

</script>

<style >


</style>
